import { render } from "./message-msg-box-propt.vue?vue&type=template&id=7a6c78f0&scoped=true&ts=true"
import script from "./message-msg-box-propt.vue?vue&type=script&lang=ts"
export * from "./message-msg-box-propt.vue?vue&type=script&lang=ts"

import "./message-msg-box-propt.vue?vue&type=style&index=0&id=7a6c78f0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6c78f0"]])

export default __exports__